import type { IOption } from 'common/interfaces/IOption'

export const PATIENT_ACTIVITY_INTERVAL: IOption[] = [
  { code: 15, name: '15 min' },
  { code: 20, name: '20 min' },
  { code: 25, name: '25 min' },
  { code: 30, name: '30 min' },
]
